import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IvfDialogComponent } from './ivf-dialog/ivf-dialog.component';
import { TreatmentDialogComponent } from './treatment-dialog/treatment-dialog.component';
import { PharmacyDialogComponent } from './pharmacy-dialog/pharmacy-dialog.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { EmailDialogComponent } from './email-dialog/email-dialog.component';
import { EmailSuccessComponent } from './email-success/email-success.component';
import { InterstitialDirective } from './interstitial.directive';
import { InterstitialDialogComponent } from './interstitial-dialog/interstitial-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { RecaptchaModule } from 'ng-recaptcha';

@NgModule({
  declarations: [
    TreatmentDialogComponent,
    IvfDialogComponent,
    PharmacyDialogComponent,
    ContactUsComponent,
    EmailDialogComponent,
    EmailSuccessComponent,
    InterstitialDirective,
    InterstitialDialogComponent,
    ConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule
  ],
  entryComponents: [
    TreatmentDialogComponent,
    IvfDialogComponent,
    PharmacyDialogComponent,
    ContactUsComponent,
    EmailDialogComponent,
    EmailSuccessComponent,
    InterstitialDialogComponent,
    ConfirmationDialogComponent
  ],
  exports: [
    TreatmentDialogComponent,
    IvfDialogComponent,
    PharmacyDialogComponent,
    ContactUsComponent,
    EmailDialogComponent,
    EmailSuccessComponent,
    InterstitialDirective,
    InterstitialDialogComponent,
    ConfirmationDialogComponent
  ]
})
export class DialogsModule {}
